import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaDateDefinition } from './TypedDefinition'

export const SchemaDatePlugin = createSchemaPlugin(
  'Schema.Date',
  SchemaDateDefinition
)
